import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X, Phone, BookOpen } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Scroll detection for header background
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className={`text-white transition-all duration-300 fixed top-0 left-0 w-full z-50 ${
      isScrolled 
        ? "bg-black/95 shadow-lg border-b border-white/20 backdrop-blur-md" 
        : "bg-black/30 backdrop-blur-sm"
    }`}>
      <div className="container mx-auto px-6 py-2">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/images/Logo/ELLOGOEN.png" 
              alt="El Samán Luxury Design" 
              className="h-24 w-auto object-contain transition-all duration-300 logo-hero-hover hover:opacity-90"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-white hover:text-[#C6A76D] transition-colors font-medium text-base"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('productos')}
              className="text-white hover:text-[#C6A76D] transition-colors font-medium text-base"
            >
              Productos
            </button>
            <a
              href="https://catalogo-elsaman.vercel.app"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-[#C6A76D] transition-colors font-medium text-base"
            >
              Catálogo Completo
            </a>
            <button
              onClick={() => scrollToSection('nosotros')}
              className="text-white hover:text-[#C6A76D] transition-colors font-medium text-base"
            >
              Nosotros
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-white hover:text-[#C6A76D] transition-colors font-medium text-base"
            >
              Contacto
            </button>
            <a
              href="https://catalogo-elsaman.vercel.app"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 bg-[#C6A76D] text-white rounded-md hover:bg-[#B5975E] transition-colors font-medium"
            >
              <BookOpen size={18} />
              Ver Catálogo
            </a>
          </nav>

          {/* Contact Info & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-base text-white/90">
              <Phone size={18} />
              <span className="font-medium">221 251 2363</span>
            </div>
            <a
              href="https://catalogo-elsaman.vercel.app"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-md bg-white/10 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
            >
              Ver Catálogo
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-20 left-0 right-0 bg-black/95 backdrop-blur-md border-b border-white/20 shadow-lg">
            <nav className="container mx-auto px-6 py-6 space-y-4">
              <button
                onClick={() => scrollToSection('inicio')}
                className="block w-full text-left text-white hover:text-[#C6A76D] transition-colors py-3 font-medium text-lg"
              >
                Inicio
              </button>
              <button
                onClick={() => scrollToSection('productos')}
                className="block w-full text-left text-white hover:text-[#C6A76D] transition-colors py-3 font-medium text-lg"
              >
                Productos
              </button>
              <a
                href="https://catalogo-elsaman.vercel.app"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-left text-white hover:text-[#C6A76D] transition-colors py-3 font-medium text-lg"
                onClick={() => setIsMenuOpen(false)}
              >
                Catálogo Completo
              </a>
              <button
                onClick={() => scrollToSection('nosotros')}
                className="block w-full text-left text-white hover:text-[#C6A76D] transition-colors py-3 font-medium text-lg"
              >
                Nosotros
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="block w-full text-left text-white hover:text-[#C6A76D] transition-colors py-3 font-medium text-lg"
              >
                Contacto
              </button>
              <div className="pt-4 border-t border-white/20">
                <a
                  href="https://catalogo-elsaman.vercel.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex w-full items-center justify-center rounded-full bg-[#C6A76D] px-6 py-3 text-base font-bold text-black shadow-sm hover:bg-[#e2c98a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Cotizar Ahora
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;